export const FEATURED_GET_FEATURED = "FEATURED_GET_FEATURED";
export const FEATURED_GET_FEATURED_REQUESTED =
  "FEATURED_GET_FEATURED_REQUESTED";
export const FEATURED_GET_FEATURED_SUCCESS = "FEATURED_GET_FEATURED_SUCCESS";
export const FEATURED_GET_FEATURED_FAILED = "FEATURED_GET_FEATURED_FAILED";
